import React from 'react';
import {inject, observer} from 'mobx-react';
import * as mobx from 'mobx';
import {getAntd, getEcCom,getLabel } from '../../util/convert';
import {showAuthDialog} from "../../util/secondAuthUtil"
import * as authTypes from "../../constants/secondAuthType";
import {scrollDom} from './../../util/formUtil'
@inject("globalStore")
export default class Main extends React.Component {
    render() {
        return (
            <div className="wf-freeWFsimple-msg">
                <i className="icon-coms-Prompt" />  
                <span className='wf-freeWFsimple-msg-text'>{getLabel(514309,"提交流程前请先确认流转设定设置")}，</span>
                <a href="javascript:void(0);" onClick={this.scrollDom}>{getLabel(512307,"查看详情")}</a> 
            </div>
        )
    }
    scrollDom = () =>{
        const {tabKey, setTabKey} = this.props.globalStore;
        if(tabKey !== "form"){
            setTabKey("form")
            setTimeout(()=>{
                scrollDom(".wf-req-freeWorkflowSimple",true,getLabel(520577,"请确认流转设定设置"));
            },500)
        }else{
            scrollDom(".wf-req-freeWorkflowSimple",true,getLabel(520577,"请确认流转设定设置"));
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/topPropmpt/FreeWorkflowSimpleInfo.js